module.exports = __webpack_public_path__ + "static/media/ic_add_black.47f2add5.png";